/**
 * @generated SignedSource<<290f5f9772ed35f42e48274cea91d1f6>>
 * @relayHash cb80a4a138f9c8a6b48c659a366356eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 745f1b98563588cc73ee93ff8ae38762840f147e7f4797a5b65e63fec7cb4d69

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "745f1b98563588cc73ee93ff8ae38762840f147e7f4797a5b65e63fec7cb4d69",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
